// extracted by mini-css-extract-plugin
export var measureBox = "_bo-0";